import styled, { css } from 'styled-components'

const bannerBaseStyles = css`
  grid-column: 1;
  display: flex;
  margin: 0 auto 1rem auto;
  border-radius: 4px;
  overflow: hidden;
  border: none;
  -webkit-appearance: none;
  padding: 0;
  text-decoration: none;
  max-width: 100%;

  picture {
    width: 100%;

    > * {
      width: 100%;
      height: auto;
      display: block;
    }
  }
`

export const StyledSearchResults = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(13, auto);
  align-content: start;
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  overflow: hidden;

  > ul {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: subgrid;
    grid-column: 1;
    grid-row: 1 / span 13;
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow: hidden;
    min-width: 0;

    > li {
      grid-column: 1;
      grid-row: auto;
      min-width: 0;
      overflow: hidden;

      article {
        height: auto;
      }

      ${createNthChildCSS()}
    }
  }

  > [data-testid='merch-banner'] {
    ${bannerBaseStyles}
    grid-row: 8;
  }
`

function createNthChildCSS() {
  let styles = ''

  for (let i = 8; i < 13; i += 1) {
    styles += `
       &:nth-child(${i}) {
         grid-row: ${i + 1};
       }
     `
  }

  return css`
    ${styles}
  `
}
